import AnimMediaControl from './anim-media-control';
import type { IMediaParams } from '@src/slide/application/service/media-manager/params.interface';
import { MediaRegion, type IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { VIDEO_STATE } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';
import { PlayerType } from '@src/slide/application/service/note-view-media-sync-manager/core/note-view-media-sync-manager.interface';

export default class PlayerAnimVideoControl extends AnimMediaControl {
    public static instance: PlayerAnimVideoControl;
    public static getInstance(mediaManager: IMediaManager): PlayerAnimVideoControl {
        if (!this.instance) {
            this.instance = new PlayerAnimVideoControl(mediaManager);
        }
        return this.instance;
    }

    public isPlaying(): boolean {
        const mediaInstance = this.getMediaInstance(this.elementModel.key) as any;
        if (mediaInstance?.playerType === PlayerType.WEB) {
            return mediaInstance?.state === VIDEO_STATE.PLAYING;
        }
        if (mediaInstance?.playerType === PlayerType.DESKTOP) {
            return mediaInstance?.isPlaying;
        }

        return false;
    }

    public completeMediaControl(mediaParams: IMediaParams): void | undefined {
        this.mediaManager.pauseVideoByRegion(mediaParams.elementModel.key, MediaRegion.PLAYER);
    }

    // media开始播放
    protected playHandler(): void {
        const { mediaManager } = this;
        if (!mediaManager) return;
        mediaManager.playVideoByRegion(this.elementModel.key, MediaRegion.PLAYER);
    }

    // 演示态下togglePause的行为: 若视频播放则暂停，若视频暂停则播放
    protected togglePauseHandler(): void {
        // 由于桌面端播放器根据key值播放或暂停视频，桌面端不响应触发器动画
        if (this.getMediaInstance(this.elementModel.key)?.playerType === PlayerType.DESKTOP) return;
        this.isPlaying() ? this.stopHandler() : this.playHandler();
    }

    // media停止播放
    protected stopHandler(): void {
        const { mediaManager } = this;
        if (!mediaManager) return;
        mediaManager.pauseVideoByRegion(this.elementModel.key, MediaRegion.PLAYER);
    }

    /**
     * 获取演Video实例
     * @returns super player实例
     */
    protected getMediaInstance(elementModelKey: string) {
        return this.mediaManager?.getVideoInstanceByRegion(elementModelKey, MediaRegion.PLAYER) as any;
    }
}
